import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51070489"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download-table-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Sicco Check Plan ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Download ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx._visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._visible) = $event)),
    onCancel: _ctx.handleCancel
  }, {
    title: _withCtx(() => [
      _hoisted_3
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, { onClick: _ctx.handleCancel }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.handleDownload,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_table, {
          scroll: { y: 200 },
          dataSource: _ctx.data,
          columns: _ctx.column,
          rowKey: "id",
          pagination: false,
          rowSelection: _ctx.tableSelection
        }, {
          link: _withCtx(({ record }) => [
            _renderSlot(_ctx.$slots, "link", { row: record }, undefined, true)
          ]),
          operation: _withCtx(({ record }) => [
            _createElementVNode("span", {
              class: "link",
              onClick: ($event: any) => (_ctx.handleSetClick(record))
            }, "Set", 8, _hoisted_2)
          ]),
          _: 3
        }, 8, ["dataSource", "columns", "rowSelection"])
      ])
    ]),
    _: 3
  }, 8, ["visible", "onCancel"]))
}